import React, { useState } from 'react';
import icon from './images/Not-allowed.svg';
import './styles/CustomModal.css';

const CustomModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // Ensure no modal is shown if not open

  return (
    <div className="modal-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content medium-modal">
        <h2 className="modal-title heading-with-image">
          <img src={icon} alt="icon" className="heading-icon" />
          Unable to Edit/Delete/Deactivate
        </h2>
        <div className="modal-message">
          <div>
            This item cannot be edited, deleted or deactivated because it is
            currently linked to an active workflow in Subscriber Connect.
          </div>
          <div>
            Return here to complete the edit, deletion, or deactivation.
          </div>
          <div className="subHeading">To resolve this:</div>
          <ul>
            <li>
              <span className="bullet"></span>Go to Elements Workspace.
            </li>
            <li>
              <span className="bullet"></span>Navigate to the Subscriber Connect
              configuration.
            </li>
            <li>
              <span className="bullet"></span>Deselect/Remove the item from the
              workflow configuation.
            </li>
            <li>
              <span className="bullet"></span>Return here to complete the edit,
              deletion or deactivation.
            </li>
          </ul>
        </div>
        <div className="modal-close-button" onClick={onClose}>
          Got it
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
